import { Link, type LinkProps } from 'react-router-dom'
import { scrollToTop } from '@/lib/scrollToTop'

/** In-app link that scrolls to top even when the destination is already active. */
export function StoreScrollLink({ onClick, ...props }: LinkProps) {
  return (
    <Link
      {...props}
      onClick={(e) => {
        onClick?.(e)
        if (!e.defaultPrevented) {
          scrollToTop()
        }
      }}
    />
  )
}
